import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "13",
  height: "16",
  fill: "none",
  viewBox: "0 0 13 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m11.394 5.236 1.485-1.485-1.131-1.132-1.546 1.546a6.45 6.45 0 0 0-2.903-1.11V1.6h1.2V0h-4v1.6h1.2v1.455C2.492 3.451 0 6.188 0 9.5 0 13.084 2.915 16 6.499 16s6.5-2.916 6.5-6.5a6.47 6.47 0 0 0-1.605-4.264m-2.746 4.955a1.3 1.3 0 0 1-.157.354l-1.863 3.241-1.387-.797 1.85-3.217-.383.242c-.374.221-.812.28-1.226.17a1.604 1.604 0 0 1-1.132-1.96c.045-.168.119-.29.163-.363l1.521-2.647 1.387.797-1.512 2.634.381-.242a1.597 1.597 0 0 1 2.358 1.788"
    }, null, -1)
  ])))
}
export default { render: render }